var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("nav", {
    staticClass: "nav-menu",
    class: {
      dark: _vm.darkRouteNameArray.includes(_vm.routeName),
      beinmiddle: _vm.scrollTop > 60
    }
  }, [_c("ul", {
    staticClass: "nav-menu__list clearfix"
  }, _vm._l(_vm.menuList, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "menu-item",
      class: {
        "menu-active": _vm.$route.path.includes(item.url),
        disabled: item.disabled
      },
      on: {
        mouseenter: function ($event) {
          return _vm.handleMouseenter(index, item);
        },
        mouseleave: function ($event) {
          return _vm.handleMouseleave();
        }
      }
    }, [_c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.disabled && _vm.subMenuShowIndex === index,
        expression: "item.disabled && subMenuShowIndex === index"
      }],
      staticClass: "self-tip"
    }, [_c("div", {
      staticClass: "arrow"
    }), _vm._m(0, true)]), _c("span", {
      on: {
        click: function ($event) {
          return _vm.handleMenuClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.menu_name) + " "), item.children.length ? _c("img", {
      attrs: {
        src: require("@/assets/images/expand_dark.png"),
        alt: ""
      }
    }) : _vm._e()]), _c("transition", {
      attrs: {
        name: "fade-in-linear"
      }
    }, [_c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.subMenuShowIndex === index && item.children.length,
        expression: "subMenuShowIndex === index && item.children.length"
      }],
      staticClass: "triangle"
    })]), _c("transition", {
      attrs: {
        name: "fade-in-linear"
      }
    }, [_c("section", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.subMenuShowIndex === index,
        expression: "subMenuShowIndex === index"
      }],
      staticClass: "sub-menu-wrapper",
      style: _vm.subMenuStyle(index)
    }, [_c("sub-menu", {
      attrs: {
        subMenuList: item.children,
        menuName: item.menu_name,
        productMenu: _vm.productMenu
      },
      on: {
        closeSubMenu: function ($event) {
          _vm.subMenuShowIndex = -1;
        }
      }
    })], 1)])], 1);
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "self-tip-content"
  }, [_c("div", {
    staticClass: "self-text"
  }, [_vm._v("内容建设中，敬请期待~")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };